export class UserInfoModel {
    userroles: string;
    products: any[];
    allProducts: any[];
    userId:string;
    organizationId:string;
    organizationName:string;
    organizationGUID:string;
    standaloneCustomRuleSetsEnabled: string;
}